<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar valores do contrato
          </h4>
        </div>
        <div class="modal-body">
          <div v-if="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
          </div>
          <table class="table table-striped modal__table">
            <tbody>
              <tr>
                <th>ID do contrato</th>
                <td>{{ contract.id }}</td>
              </tr>
              <tr>
                <th>Valor sem desconto</th>
                <td>R$ {{ contract.installment_without_discount }}</td>
              </tr>
              <tr>
                <th>Valor com desconto</th>
                <td>R$ {{ contract.student_value }}</td>
              </tr>
              <tr>
                <th>Desconto</th>
                <td>{{ contract.discount }} %</td>
              </tr>
            </tbody>
          </table>
          <p>Novos valores:</p>
          <money-field
            label="Valor sem desconto"
            v-model="contractForm.get('fullValue').value"
            :errors="contractForm.get('fullValue').errors"
            @input="contractForm.get('fullValue').validateField()"
          />
          <money-field
            label="Valor com desconto"
            v-model="contractForm.get('studentValue').value"
            :errors="contractForm.get('studentValue').errors"
            @input="contractForm.get('studentValue').validateField()"
          />
          <table class="table table-striped modal__table">
            <tbody>
              <tr>
                <th>Novo Desconto:</th>
                <td id="calculatedDiscount">
                  {{ calculateDiscount }} %
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="changeContractValue">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { MoneyField } from 'components/form';
import { FormGroup } from 'utils/form';
import ContractsService from 'services/ContractsService';

export default {
  components: {
    MoneyField,
  },
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      contractForm: new FormGroup({
        fullValue: {
          required: true,
          value: 0,
        },
        studentValue: {
          required: true,
          value: 0,
        },
      }),
      errorMessage: null,
    };
  },
  computed: {
    calculateDiscount() {
      const studentValue = this.contractForm.get('studentValue').value;
      const fullValue = this.contractForm.get('fullValue').value;
      const discountValue = (1 - studentValue / fullValue) * 100;

      return Number.isNaN(discountValue) ? 0 : discountValue.toFixed(2);
    },
  },
  methods: {
    ...mapActions([
      'loadStudentBills',
      'loadStudentBillings',
      'loadStudentContracts',
    ]),
    changeContractValue() {
      this.$loader.show();

      const payload = this.contractForm.getRawValue();

      ContractsService.changeContractValue(this.contract.id, payload)
        .then(() => this.loadStudentContracts())
        .then(() => {
          this.$emit('close');
          this.$alert.notifySuccess('Alteração efetuada com sucesso');
        })
        .catch(() => {
          this.errorMessage = 'Erro ao Alterar o valor';
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
  },
};
</script>
